import { createWsConnectThunks, WsPrefixes } from '@skynet/data-ws-core';
import type { WsSmmState } from './slice';

export type SmmWsState = { wsSmm: WsSmmState };

const { wsLogout, wsDisconnect, subscribeWsData } = createWsConnectThunks({
  sliceKey: 'wsSmm',
  prefix: WsPrefixes.smmPrefix,
  logoutCommand: 'Logout',
  disconnectCommand: 'Disconnect',
});

export {
  wsLogout as wsSmmLogout,
  wsDisconnect as wsSmmDisconnect,
  subscribeWsData as subscribeWsSmmData,
};
